import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import SwipeableTextMobileStepper from "./MobileStepper";
import { SecondaryStyle } from "../fonts";

import LA from "../assets/Page1LA.webp";
import LC from "../assets/Page1LC.webp";
import RB from "../assets/Page1RB.webp";
import RA1 from "../assets/Page1RA1.webp";
import RA2 from "../assets/Page1RA2.webp";

//@ts-ignore
import LB from "../assets/Page1LB.mp4";

const carousel1Images = [RA1, RA2];

const Page1 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{
                height: "100%",
                borderTop: { xs: "1vh solid #fff", sm: "none" },
              }}
            >
              {/* LA/LD */}
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                    width: "100%",
                    maxHeight: { xs: "100%", sm: "50vh" },
                  }}
                >
                  {/* LC */}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      height: {
                        xs: "45vh",
                        sm: "100%",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      maxHeight: "50vh",
                      borderBottom: ".5vh solid #fff",
                      backgroundImage: `url('${LA}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              {/** */}
              <Grid item xs={12} sm={6}>
                <Grid container direction={"row"} sx={{ height: "100%" }}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: ".5vh solid #fff",
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },

                      height: {
                        xs: "46vh",
                        sm: "100%",
                      },

                      backgroundImage: `url('${LC}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      maxHeight: { xs: "100%", sm: "50vh" },
                    }}
                  />

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      maxHeight: "50vh",
                      borderTop: ".5vh solid #fff",

                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: {
                          xs: "45vh",
                          sm: "100%",
                        },
                        maxHeight: "50vh",

                        objectFit: "cover",
                      }}
                      src={LB}
                      playsInline
                      autoPlay
                      muted
                      loop
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              {/* RD/RA */}
              <Grid container direction={"row"}>
                {/* RD */} {/* RA */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    px: { xs: 1.5, md: 1.5, lg: 2, xl: 3 },
                    pb: { xs: 1.5 },
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      ...SecondaryStyle,

                      textAlign: { xs: "justify", sm: "left" },
                      "@media (orientation: landscape)": {
                        fontSize: { xs: "1vw", md: "1vw", lg: "0.95vw" },
                        lineHeight: {
                          xs: "1.5vw",
                          md: "1.5vw",
                          lg: "1.25vw",
                        },
                      },
                      "@media (orientation: portrait)": {
                        fontSize: { xs: "1.7vh", sm: "1vh" },
                        lineHeight: {
                          xs: "2vh",
                          sm: "1.5vh",
                          md: "1.5vh",
                          lg: "1.5vh",
                        },
                        paddingTop: {
                          xs: "1vh",
                          sm: "2vh",
                          md: "2vh",
                          lg: "2vh",
                        },
                      },
                    }}
                  >
                    This charming Edwardian home invites you in with timeless
                    curb appeal. A covered porch overlooks a lush front yard,
                    creating a peaceful oasis in the heart of Seaton Village.
                    Step inside to a bright foyer where natural light streams
                    through stained glass windows, highlighting warm hardwood
                    floors and the graceful flow of the space. The foyer’s
                    inviting atmosphere sets the tone for the home, offering the
                    perfect balance of privacy and connection. Whether you're
                    greeting family after a busy day or welcoming guests for a
                    cozy evening, this home exudes warmth and character, ideal
                    for families who appreciate a blend of elegance and comfort.
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    height: {
                      xs: "35.5vh",
                      sm: "50vh",
                    },
                    borderTop: {
                      xs: ".5vh solid #fff",
                      sm: "none",
                    },
                    borderRight: {
                      xs: "1vh solid #fff",
                      sm: "none",
                    },
                    borderLeft: {
                      xs: "1vh solid #fff",
                      sm: ".5vh solid #fff",
                    },
                    borderBottom: ".5vh solid #fff",
                  }}
                >
                  <SwipeableTextMobileStepper images={carousel1Images} />
                </Grid>
                {/**RC */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    backgroundImage: `url('${RB}')`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: { xs: "16px", sm: "0vh" },
                    borderTop: {
                      xs: ".5vh solid #fff",
                      sm: ".5vh solid #fff",
                    },
                    borderLeft: {
                      xs: "1vh solid #fff",
                      sm: ".5vh solid #fffe",
                    },
                    borderBottom: { xs: "1vh solid #fff", sm: "none" },
                    borderRight: {
                      xs: "1vh solid #fff",
                      sm: "none",
                    },
                    height: {
                      xs: "46vh",
                      sm: "100%",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page1;
